import _ from 'lodash'

import Vue from 'vue'

import { store } from '_/vuex/store'

const InputTag = Vue.component(
  'InputTag',
  require('_/components/FieldTypes/InputTag/InputTag.vue').default
)

import { mapGetters } from 'vuex'

export default {
  /**
   * Define props
   *
   * @type  {Object}
   */
  props: {
    advancedSearchName: {
      required: true,
      type: String,
    },
    id: {
      required: true,
      type: Number,
    },
    isSystem: {
      type: Boolean,
      default: false,
    },
    label: {
      required: true,
      type: String,
    },
    name: {
      required: true,
      type: String,
    },
    refreshFields: {
      type: Number,
    },
    translatable: {
      default: false,
      type: Boolean,
    },
  },

  /**
   * Define components
   *
   * @type  {Object}
   */
  components: {
    InputTag,
  },

  /**
   * Set the computed properties
   *
   * @type {object}
   */
  computed: {
    ...mapGetters({
      ui: 'ui/ui',
    }),

    /**
     * advancedSearch model getter
     *
     * @return  {object}
     */
    advancedSearch() {
      const getterName = `${this.advancedSearchName}/${this.advancedSearchName}`

      return this.$store.getters[getterName]
    },

    /**
     * Gets the value
     *
     * @return  {string}
     */
    value() {
      const path = `payload.filter.${this.filterGroup}.${this.name}.like`

      if (_.has(this.advancedSearch, path)) {
        return this.advancedSearch.payload.filter[this.filterGroup][this.name]
          .like
      }

      return null
    },

    filterGroup() {
      return this.isSystem ? 'system' : 'fields'
    },
  },

  /**
   * Set the methods
   *
   * @type  {Object}
   */
  methods: {
    /**
     * Define a method that runs on change event
     *
     * @param   {string}  options.name
     * @param   {string}  options.value
     * @return  {void}
     */
    onChange({ name, value }) {
      store.dispatch(`${this.advancedSearchName}/updateFilterValue`, {
        fieldName: name,
        value,
      })
    },
  },

  /**
   * Set the beforeDestroy hook
   *
   * @return  {void}
   */
  beforeDestroy() {
    store.dispatch(`${this.advancedSearchName}/removeFilter`, {
      fieldName: `filter.${this.filterGroup}.${this.name}`,
    })
  },
}
